define('bindingHandlers/timeline',[
    'jquery',
    'lib/knockout',
    'util/codeUtils',
    'lib/vis'

], function($, ko, codeUtil, vis) {
    'use strict';

    // Usage: <div data-bind="visTimeline: { data: dataSet, groups: groupDataSet, options: timelineOptions, callback: callAfterTimelineCreated}"></div>
    // See http://visjs.org/docs/timeline/#Data_Format for available data types for dataSet and groupDataSet
    // See http://visjs.org/docs/timeline/#Configuration_Options for available timelineOptions values

    ko.bindingHandlers.visTimeline = {
        init: function(element, valueAccessor) {
            var bindingData = ko.unwrap(valueAccessor());
            var data = bindingData.data ? ko.unwrap(bindingData.data) : new vis.DataSet();
            var groups = bindingData.groups ? ko.unwrap(bindingData.groups) : undefined;
            var options = bindingData.options ? ko.unwrap(bindingData.options) : {};
            var callback = bindingData.callback ? ko.unwrap(bindingData.callback) : undefined;
            var itemTemplateId = bindingData.itemTemplateId ? ko.unwrap(bindingData.itemTemplateId) : undefined;
            var groupTemplateId = bindingData.groupTemplateId ? ko.unwrap(bindingData.groupTemplateId) : undefined;

            if(itemTemplateId !== undefined){
              options.template = function(item) {
                  if(!document.getElementById(itemTemplateId)){
                    return document.createElement('div'); // return a default element
                  }

                  var templateHtml = document.getElementById(itemTemplateId).innerHTML;

                  // Set the template to a custom template which lets knokcout bind the items
                  // Create a div wrapper element to easily create elements from the template HTML
                  var element = document.createElement('div');
                  element.innerHTML = templateHtml;

                  // Let knockout apply bindings on the element with the template, using the item as data context
                  ko.applyBindings(item, element);

                  //Return the bound element to vis.js, for adding in the component
                  return element;
              };
            }

            if(groupTemplateId !== undefined){
              options.groupTemplate = function(item) {
                  if(!document.getElementById(groupTemplateId)){
                    return document.createElement('div'); // return a default element
                  }

                  var templateHtml = document.getElementById(groupTemplateId).innerHTML;

                  // Set the template to a custom template which lets knokcout bind the items
                  // Create a div wrapper element to easily create elements from the template HTML
                  var element = document.createElement('div');
                  element.innerHTML = templateHtml;

                  // Let knockout apply bindings on the element with the template, using the item as data context
                  ko.applyBindings(item, element);

                  //Return the bound element to vis.js, for adding in the component
                  return element;
              };
            }

            //Apply the vis.js timeline component
            var timeline = new vis.Timeline(element, data, groups, options);
            timeline.redraw();

            if (callback !== undefined) {
                callback(timeline);
            }

            //Let knockout know that we want to handle bindings for child items manually
            return {
                controlsDescendantBindings: true
            };
        }
    };
});

